import { useCandidatesMetrics } from "./useCandidatesMetrics";

type CountBaseParams = {
  clientId?: string;
  tenantId: string | null;
  search?: string;
  startDate: string;
  endDate: string;
};

/**
 * Live candidate count for the filters drawer header. Invoked from the drawer with its pending
 * (not-yet-applied) filter selection so the displayed total updates as the user toggles checkboxes.
 * Reuses the aggregated metrics endpoint (totalCandidates) — no dedicated count endpoint exists.
 *
 * When the page is client-scoped (baseParams.clientId set), the clients filter locks to that single
 * client; otherwise it falls through to the pending selection.
 */
export function useCandidatesFilteredCount(
  baseParams: CountBaseParams,
  filterKeys: readonly string[],
  pendingFilters: Record<string, string[]>,
): { count: number; isLoading: boolean } {
  const pending: Record<string, string[] | undefined> = {};
  for (const key of filterKeys) {
    const values = pendingFilters[key];
    pending[key + "s"] = values && values.length ? values : undefined;
  }
  const { data, isLoading } = useCandidatesMetrics({
    ...baseParams,
    clients: baseParams.clientId ? [baseParams.clientId] : pending.clients,
    integrations: pending.integrations,
    publicationIds: pending.publicationIds,
    matchIds: pending.matchIds,
    candidateIds: pending.candidateIds,
  });
  return { count: data?.totalCandidates ?? 0, isLoading };
}
